import React from 'react'
import TrackRouter from 'routers/Track'

const TrackApp = props => (
  <>
    <TrackRouter {...props} />
  </>
)

export default TrackApp